import React from 'react'
import { CButton } from '@coreui/react'

function Pager({ page, total, onPage }) {
  if (total <= 1) return null

  return (
    <div className="pager">
      {Array.from({ length: total }, (_, index) => index + 1).map((item) => (
        <CButton key={item} color={item === page ? 'success' : 'light'} size="sm" onClick={() => onPage(item)}>
          {item}
        </CButton>
      ))}
    </div>
  )
}

export default Pager
